import moment, { type Moment } from 'moment'

type DateArg = Date | Moment

export function isToday(date: DateArg): boolean {
  return moment(date).isSame(moment(), 'day')
}

export function isCurrentHour(date: DateArg): boolean {
  return moment(date).isSame(moment(), 'hour')
}

export function isInPast(date: DateArg): boolean {
  return moment(date).isBefore(moment())
}

export function startOfCurrentHour(date: DateArg): Date {
  return moment(date).startOf('hour').toDate()
}
